export default (opt = {}) => {
    let editor = opt.editor,
        styleManager = editor.StyleManager;

    styleManager.addType('pmw-input-field', {
        /**
         *
         * @param {object} props
         * @param {string} props.type this style component's type
         * @param {string} props.property property of the component to track input changes in
         * @param {grapesjs.Component} props.component
         * @param {string} props.label
         * @param {string} props.placeholder
         * @param {string} props.labelClass
         * @param {array} props.containerClass
         * @param {string} props.inputContainerClass
         * @param {string} props.inputClass
         * @param {string} props.icon
         * @param {function} props.cb callback executed after input's change event, gets (component, value, event) passed as arguments -
         * bound component, escaped input value, triggered event
         * @param {string} props.eventType event type to listen to, defaults to 'change'
         * @return {HTMLElement}
         */
        create({props}) {
            props.component = props.component || editor.getSelected();
            props.placeholder = props.placeholder || '';
            props.labelClass = props.labelClass || '';
            props.containerClass = props.containerClass || '';
            props.inputClass = props.inputClass || '';
            props.inputContainerClass = props.inputContainerClass || '';
            props.label = props.label || '';
            props.icon = props.icon || '';
            props.eventType = props.eventType || 'change';

            const container = document.createElement('div'),
                label = document.createElement('label'),
                span = document.createElement('span'),
                input = document.createElement('input'),
                icon = document.createElement('i');

            container.className = `${props.type} input-field-container ${props.containerClass}`;
            label.className = `field-label body-xs ${props.labelClass}`;
            label.htmlFor = `input-field`;
            input.className = `field-input body-xs ${props.inputClass} js-field-input-${props.property}`;
            input.id = `input-field`;
            input.value = props.component?.get(props.property) || '';
            input.placeholder = props.placeholder;
            icon.className = `icon size-icon-20 icon-${props.icon}`;
            span.className = `field-input-container ${props.inputContainerClass}`;

            if (props.label) {
                label.append(props.label);
                container.append(label);
            }

            span.append(input);

            if (props.icon) {
                span.append(icon);
            }

            container.append(span);

            input.addEventListener(props.eventType, event => {
                const inputVal = event.target.value.trim();

                props.component?.set(props.property, inputVal);
                if (typeof props.cb === 'function') {
                    props.cb(props.component, inputVal, event);
                }
            });

            return container;
        },
        emit({props}, {li, component, property}) {
        },

        update({value, el}) {
        }
    });
}